import React, { Component } from 'react'

import Portal from '../../components/Portal'

import './privacypolicy.scss'

// Modals
import PrivacyPolicyModal from '../../modals/PrivacyPolicyModal'

class PrivacyPolicy extends Component {
  constructor (props) {
    super(props)
    this.state = {
      showModal: false
    }

    this.toggleShow = this.toggleShow.bind(this)
  }

  toggleShow (e) {
    if (e !== undefined) {
      e.preventDefault()
    }
    this.setState({
      showModal: !this.state.showModal
    })
  }

  render () {
    return (
      <div className='privacy-policy__item'>
        <a href='' onClick={this.toggleShow.bind(this)}>{this.props.text}</a>
        <Portal onPortalClose={this.toggleShow.bind(this)}>
          <PrivacyPolicyModal show={this.state.showModal} onClose={this.toggleShow.bind(this)} />
        </Portal>
      </div>
    )
  }
}

export default PrivacyPolicy



// WEBPACK FOOTER //
// ./src/app/shared/components/PrivacyPolicy/index.js